import React, { useState, useEffect } from "react";

export default ({
  fields,
  validationErrors,
  handleChange,
  gardians,
  setGardians,
  editkey
}) => {
  return (
    <>
      <label htmlFor="name">
        Enter the player and parent/guardian name below:
      </label>
      <div className="row">
        <div className="form-group col-md-6">
          <label htmlFor="name">How many children ? {editkey ? "" : "*"}</label>
          <input
            type="number"
            className="form-control"
            id="exampleInputName1"
            name="children_details"
            onChange={handleChange("children_details")}
            value={fields.children_details}
          />
          {validationErrors.children_details && (
            <div className="text-danger err">
              {validationErrors.children_details}
            </div>
          )}
        </div>
        <div className="form-group col-md-6">
          <label htmlFor="name">Parent / Guardian First Name {editkey ? "" : "*"}</label>
          <input
            type="text"
            className="form-control"
            id="exampleInputName1"
            placeholder="Parent / Guardian First Name*"
            name="parent_name"
            onChange={handleChange("parent_name")}
            value={fields.parent_name}
          />
          {validationErrors.parent_name && (
            <div className="text-danger err">
              {validationErrors.parent_name}
            </div>
          )}
        </div>
        <div className="form-group col-md-6">
          <label htmlFor="name">Parent / Guardian Last Name {editkey ? "" : "*"}</label>
          <input
            type="text"
            className="form-control"
            id="exampleInputName1"
            placeholder="Parent / Guardian Last Name*"
            name="parent_last_name"
            onChange={handleChange("parent_last_name")}
            value={fields.parent_last_name}
          />
          {validationErrors.parent_last_name && (
            <div className="text-danger err">
              {validationErrors.parent_last_name}
            </div>
          )}
        </div>
        <div className="form-group col-md-6">
          <label htmlFor="name">
            {" "}
            What is your relationship with player? {editkey ? "" : "*"}
          </label>
          <div className="col-md-12">
            <select
              className="form-select"
              name="relationship"
              onChange={handleChange("relationship")}
              value={fields.relationship}
            >
              <option value="" selected disabled>
                Select{" "}
              </option>
              <option
                value="dad"
                selected={fields?.relationship === "dad" ? "selected" : ""}
              >
                Dad{" "}
              </option>
              <option
                value="mom"
                selected={fields?.relationship === "mom" ? "selected" : ""}
              >
                Mom{" "}
              </option>
              <option
                value="brother"
                selected={fields?.relationship === "brother" ? "selected" : ""}
              >
                Brother{" "}
              </option>
              <option
                value="sister"
                selected={fields?.relationship === "sister" ? "selected" : ""}
              >
                Sister{" "}
              </option>
            </select>
            {validationErrors.relationship && (
              <div className="text-danger err">
                {validationErrors.relationship}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
